/** A labeled inline text input (single line or multiline). */
interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  multiline?: boolean;
  maxLength?: number;
}

export function TextField({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  multiline = false,
  maxLength = 300,
}: TextFieldProps) {
  return (
    <label className="field" htmlFor={id}>
      <span className="field-label">
        {label}
        {required && <span className="req" aria-hidden="true"> *</span>}
      </span>
      {multiline ? (
        <textarea
          id={id}
          className="field-input"
          value={value}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          rows={2}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <input
          id={id}
          className="field-input"
          type="text"
          value={value}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </label>
  );
}
